import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
@Component({
    selector: 'iWindow-app',
    templateUrl: './iWindow.component.html',
    styleUrls: ["./iWindow.component.scss"]
  })
  export class iWindowComponent {
    @Input() place: any;
    
    

    onChange(val: any) { 
     
      this.place = val; 
    } 
  }

 


// WEBPACK FOOTER //
// ./src/app/component/blocks/infoWindow/iWindow.component.ts